export default {
  methods: {
    onlyNumber ($event) {
      const codes = [13, 27, 46]
      const keyCode = ($event.keyCode ? $event.keyCode : $event.which)
      // if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
      if ((keyCode < 48 || keyCode > 57) && codes.indexOf(keyCode) === -1) { // 46 is dot
        $event.preventDefault()
      }
    }
  }
}
